import React from 'react'
import { useAuth } from 'hooks/auth'
import { ORG_PLAN_TIERS } from 'app-constants'

interface SubscriptionProps {
  type: 'paid' | 'team' | 'scale'
  message: string
}

const Message = ({ message }: { message: string }) => (
  <div
    className="text-sm mb-4 font-bold flex items-center justify-center p-2 rounded-lg bg-alert text-on-light border border-divider-strong"
    data-testid="subscription-message"
  >
    Contact{' '}
    <a className="ml-[5px] mr-[5px]" href="mailto:mo@morta.io">
      mo@morta.io
    </a>{' '}
    to upgrade to {message}.
  </div>
)

const Subscription: React.FC<SubscriptionProps> = ({ type, message }) => {
  const { user, onPaidPlan } = useAuth()
  const orgPlanTier = user?.team?.orgPlanTier || ORG_PLAN_TIERS.PROFESSIONAL

  if (type === 'scale' && user && orgPlanTier !== ORG_PLAN_TIERS.SCALE_UP) {
    return <Message message={`the Scale Up plan to ${message}`} />
  } else if (type === 'team' && user && orgPlanTier === ORG_PLAN_TIERS.PROFESSIONAL) {
    return <Message message={`the Team plan to ${message}`} />
  } else if (type === 'paid' && user && !onPaidPlan) {
    return <Message message={`a Paid Plan to ${message}`} />
  } else return null
}

export default Subscription
